import { render, staticRenderFns } from "./CatTreeItem.vue?vue&type=template&id=80ff9094"
import script from "./CatTreeItem.vue?vue&type=script&lang=js"
export * from "./CatTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports